module.exports = __webpack_public_path__ + "static/media/cancelled.2330e132.svg";